<div>
  <div class="flex-row">
    <div class="flex-column">
      <h3>Validating logon information, please wait.</h3>
    </div>
  </div>
</div>
